<template>
  <el-dialog
    title="标记退回"
    :visible.sync="dialogFormVisible"
    width="550px"
    @close="closeBackEdit"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="退回原因" prop="selectedReason">
        <el-select
          v-model="form.selectedReason"
          clearable
          placeholder="请选择退回原因"
        >
          <el-option
            v-for="item in selectedReasonOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="wroteReason">
        <el-input
          type="textarea"
          :rows="3"
          v-model.trim="form.wroteReason"
          autocomplete="off"
          placeholder="自定义文档框（50个汉字）"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div class="footer-tips">点击确认即发邮件通知采购</div>
      <div>
        <el-button @click="closeBackEdit">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "MarkBack",
  data() {
    return {
      form: {
        selectedReason: "",
        wroteReason: "",
      },
      invoiceIds: [],
      selectedReasonOptions: [
        {
          value: "金额有误",
          label: "金额有误",
        },
        {
          value: "数量有误",
          label: "数量有误",
        },
        {
          value: "订单号需确认",
          label: "订单号需确认",
        },
        {
          value: "客户开错发票",
          label: "客户开错发票",
        },
        {
          value: "自定义文本",
          label: "自定义文本",
        },
      ],
      rules: {},
      dialogFormVisible: false,
    };
  },
  created() {},
  methods: {
    /**
     * @description 打开对话框
     */
    showBackDialog(row) {
      console.log("打开对话框", row);
      this.dialogFormVisible = true;
      this.invoiceIds = row.map((item) => item.id);
    },

    /**
     * @description 关闭对话框
     */
    closeBackEdit() {
      this.$refs["form"].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },

    /**
     * @description 保存
     */
    async save() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        let params = {
          returnReason:
            this.form.wroteReason === ""
              ? this.form.selectedReason
              : this.form.wroteReason,
          userId: this.$route.query.userId,
          invoiceIds: this.invoiceIds,
        };
        // 发起请求，提交表单数据
        this.$api
          .post("/input/invoiceCompareinvoiceCompare/signBack", params)
          .then((res) => {
            this.$message.success(res.message);
            // 请求成功后触发 fetch-data 事件并关闭编辑窗口
            const { invoiceSearchData } = this.$store.state.InvoiceComparison;
            this.$emit("fetch-data", invoiceSearchData);
            this.closeBackEdit();
          })
          .catch((err) => {
            this.$message.error(err.message);
            this.closeBackEdit();
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-tips {
  font-size: 14px;
  color: #fb6b1d;
}
::v-deep .el-select {
  width: 100%;
}
</style>
